import { Box, Typography } from '@mui/material';

const PageMasthead = ({ title, subtitle, kicker, stat, statLabel, stats, accentColor = 'primary.dark' }) => {
  return (
    <Box
      sx={{
        bgcolor: '#1d2d3d',
        px: { xs: '20px', sm: '36px' },
        py: { xs: '22px', sm: '32px' },
        borderLeft: (theme) => `6px solid ${theme.palette[accentColor?.split('.')[0]]?.[accentColor?.split('.')[1]] || accentColor || '#416180'}`,
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 3,
        flexWrap: 'wrap',
      }}
    >
      <Box sx={{ minWidth: 0, flex: 1 }}>
        {kicker && (
          <Typography
            sx={{
              fontSize: '0.6875rem',
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: '0.1em',
              color: '#b5d9fd',
              mb: 0.75,
            }}
          >
            {kicker}
          </Typography>
        )}
        <Typography
          component="h1"
          sx={{
            fontFamily: '"Barlow Condensed", system-ui, sans-serif',
            fontSize: { xs: '2.125rem', sm: '2.875rem' },
            fontWeight: 600,
            lineHeight: 1.12,
            letterSpacing: '-0.015em',
            color: '#f2f2f3',
          }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography
            sx={{
              fontSize: '0.9375rem',
              color: 'rgba(242,242,243,0.75)',
              mt: 0.75,
            }}
          >
            {subtitle}
          </Typography>
        )}
      </Box>
      {/* Multiple stats */}
      {stats && stats.length > 0 && (
        <Box sx={{ display: 'flex', gap: 0, flexShrink: 0 }}>
          {stats.map((s, i) => (
            <Box
              key={i}
              sx={{
                textAlign: 'center',
                px: { xs: 2, sm: 3 },
                py: 1.5,
                borderLeft: i > 0 ? '1px solid rgba(242,242,243,0.15)' : 'none',
                minWidth: 80,
              }}
            >
              <Typography
                sx={{
                  fontSize: '0.5625rem',
                  fontWeight: 700,
                  textTransform: 'uppercase',
                  letterSpacing: '0.1em',
                  color: 'rgba(242,242,243,0.5)',
                  mb: 0.5,
                }}
              >
                {s.label}
              </Typography>
              <Typography
                sx={{
                  fontFamily: '"Barlow Condensed", system-ui, sans-serif',
                  fontSize: { xs: '1.75rem', sm: '2.25rem' },
                  fontWeight: 600,
                  lineHeight: 1,
                  color: '#f2f2f3',
                }}
              >
                {s.value}
              </Typography>
            </Box>
          ))}
        </Box>
      )}
      {/* Single stat (backward compat) */}
      {!stats && stat !== undefined && stat !== null && (
        <Box sx={{ textAlign: 'right', flexShrink: 0, alignSelf: 'flex-end' }}>
          {statLabel && (
            <Typography
              sx={{
                fontSize: '0.6875rem',
                fontWeight: 700,
                textTransform: 'uppercase',
                letterSpacing: '0.1em',
                color: 'rgba(242,242,243,0.45)',
                mb: 0.25,
              }}
            >
              {statLabel}
            </Typography>
          )}
          <Typography
            sx={{
              fontFamily: '"Barlow Condensed", system-ui, sans-serif',
              fontSize: '3rem',
              fontWeight: 600,
              lineHeight: 1,
              color: '#f2f2f3',
            }}
          >
            {stat}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default PageMasthead;
